import type { ComponentType } from 'react';
import type { CatalogDetailProps } from '../../generic-catalog-detail';

import IndependentPage1 from './bangdream/catalog_8d4fbe12ff61416bbf1d8691fe899fa3';
import IndependentPage3 from './arcanatactics/catalog_6714e36bbce44e869a6287e197359917';
import IndependentPage4 from './bangdream/catalog_b3fe245c6d9a44e7bdc072bb4d0ce436';
// Generated imports are inserted here by tools/create-independent-catalog.mjs.

const pages: Record<string, ComponentType<CatalogDetailProps>> = {
  'bangdream/catalog_8d4fbe12ff61416bbf1d8691fe899fa3': IndependentPage1,
  'arcanatactics/catalog_6714e36bbce44e869a6287e197359917': IndependentPage3,
  'bangdream/catalog_b3fe245c6d9a44e7bdc072bb4d0ce436': IndependentPage4,
  // Generated entries are inserted here by tools/create-independent-catalog.mjs.
};

export function independentCatalogPage(gameKey: string, catalogKey: string) {
  return pages[`${gameKey}/${catalogKey}`];
}
